import React from 'react'
import SUI from 'shared/components/ui/SUI'
import { Label } from 'shared/components/ui/Typography'
import KeyboardNavigator from 'components/KeyboardNavigator'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import Scroller from 'components/Scroller'
import isSearchValid from 'util/search/isSearchValid'
import isQueryStringReady from 'util/search/isQueryStringReady'
import isQueryStringNeedingValue from 'util/search/isQueryStringNeedingValue'
import { propFunc } from 'util/functions'
import { ENTER, TAB } from 'constants/keys'
import SearchFor from './SearchFor'
import Suggestion from './Suggestion'
import styles from './styles.css'

const KEY_TITLE_MAP = {
  narrow: 'Narrow your search',
  modifiers: 'Modifiers',
  keyword: 'Keywords',
  is: 'State',
  my: 'Assigned to me',
  assignee: `Assigned to ${app.t('Agent')}`,
  drafts: `Drafts by ${app.t('Agent')}`,
  group: `Assigned to ${app.t('Group')}`,
  mailbox: app.t('Mailbox'),
  label: 'Tags',
  folder: 'Folders',
}

const KEYBOARD_NAVIGATOR_KEYS = { select: [ENTER, TAB] }

export default function SearchSuggestions({
  focusElement,
  isSuggestions,
  onSelect,
  onChange,
  onChangeToSubmit,
  onSubmit,
  onMouseDown,
  searchQuery,
  suggestions,
  previousLabelSuggestionSize: prevLabelSize,
}) {
  const isNeedingValue = isQueryStringNeedingValue(searchQuery)
  const isReady = isQueryStringReady(searchQuery)
  const isInvalidSearch = !isSearchValid(searchQuery) && !isSuggestions
  return (
    <KeyboardNavigator
      className={styles.SearchSuggestions}
      focusElement={focusElement}
      onMouseDown={onMouseDown}
      activeKey={searchQuery}
      keys={KEYBOARD_NAVIGATOR_KEYS}
    >
      <SUI>
        <Scroller className={styles.SearchSuggestions_scroller}>
          {isInvalidSearch && (
            <InvalidSearchMessage searchQuery={searchQuery} />
          )}

          {isReady && (
            <SearchFor
              onSubmit={onSubmit}
              onChangeToSubmit={onChangeToSubmit}
              searchQuery={searchQuery}
            />
          )}

          {Object.keys(suggestions).map((key, groupIndex) => {
            const groupSuggestions = suggestions[key]
            if (!groupSuggestions || groupSuggestions.length < 1) return null

            const first = groupSuggestions[0]
            if (first && first.isLoading && prevLabelSize < 1) return null

            return (
              <div
                key={`group-${key}`}
                className={styles.SearchSuggestions_group}
              >
                <div className={styles.SearchSuggestions_title}>
                  <Label size="large" color="inherit">
                    {KEY_TITLE_MAP[key] || key}
                  </Label>
                </div>
                <div className={styles.SearchSuggestions_suggestions}>
                  {groupSuggestions.map((suggestion, index) => {
                    if (suggestion.isLoading) {
                      return (
                        <div
                          key={key}
                          className={styles.SearchSuggestions_loading}
                        >
                          {[...Array(prevLabelSize).keys()].map(labelIndex => (
                            <div
                              key={labelIndex}
                              className={styles.SearchSuggestions_suggestion}
                            >
                              <div className={styles.suggestion}>tag:</div>
                              <div className={styles.hint}>loading</div>
                            </div>
                          ))}
                        </div>
                      )
                    }

                    return (
                      <KeyboardNavigator.Item
                        key={key}
                        active={
                          isNeedingValue && index === 0 && groupIndex === 0
                        }
                        activeClassName={
                          styles.SearchSuggestions_activeSuggestion
                        }
                        onSelect={propFunc(onSelect, suggestion.searchQuery)}
                        onActivate={propFunc(onChange, suggestion.searchQuery)}
                      >
                        <Suggestion suggestion={suggestion} />
                      </KeyboardNavigator.Item>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </Scroller>
      </SUI>
    </KeyboardNavigator>
  )
}
